import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { TipoComunicacao } from '../../model/tipocomunicacao';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-tipocomunicacao',
  templateUrl: './tipocomunicacao.component.html',
  styleUrls: ['./tipocomunicacao.component.scss']
})
export class TipoComunicacaoComponent implements OnInit {

  movSub: Subscription;
  tipocomunicacao: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.gettipocomunicacaos();
  }

  async gettipocomunicacaos(){

    this.tipocomunicacao = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("tipocomunicacao/list").subscribe(
        (result: any) =>{

          this.tipocomunicacao =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novotipocomunicacao(){
    this.modalService.modalDetalhesTipoComunicacao.emit(null);
  }

  editar(tipocomunicacao: TipoComunicacao){
    this.modalService.modalDetalhesTipoComunicacao.emit(tipocomunicacao);
  }

  excluir(tipocomunicacao: TipoComunicacao){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("tipocomunicacao/delete", tipocomunicacao).subscribe(
            (result) =>{

              this.toastr.success('Tipo Comunicação excluído com sucesso!', 'Sucesso!');
              this.gettipocomunicacaos();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
